<script>
    export default {
        name: "Tab",

        inject: {
            tabs: {
                default() {
                    return {};
                }
            }
        },

        props: {
            title: {
                type: String,
                required: true
            },

            pill: Number | String,

            value: Number | Object
        },

        computed: {
            visible() {
                return this.tabs.activeTab() === this;
            }
        },

        render(createElement) {
            return createElement(this.tag || 'div', [this.visible ? (this.$slots.default) : createElement()]);
        },

        mounted() {
            this.tabs.registerTab(this);
        }
    }
</script>